/**
 * Devuelve la cadena eliminando todos los caracteres html, menos los elementos html de la whitelist
 * @param {string} text
 * @param {array} whiteListElementsHtml  example: ["i", "b"]
 */
export function decodeHtmlWithWhiteList(str, whiteListElementsHtml = []) {
  let r = Math.random().toString(36).substring(7) + new Date().getTime() + Math.random().toString(36).substring(7);

  let html;
  for (let tag of whiteListElementsHtml) {
    str = str.replace(new RegExp(`<${tag}`, 'gi'), `${r}${tag}${r}`);
    str = str.replace(new RegExp(`</${tag}>`, 'gi'), `${r}/${tag}${r}`);
  }
  html = str;
  var tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  html = tmp.textContent || tmp.innerText;
  for (let tag of whiteListElementsHtml) {
    html = html.replace(new RegExp(`${r}${tag}${r}`, 'gi'), `<${tag}`);
    html = html.replace(new RegExp(`${r}/${tag}${r}`, 'gi'), `</${tag}>`);
  }

  return html;
}

export function removeEmptyTags(html) {
  let text = '';
  if (html) {
    text = html.replace(/<strong>\s*<\/strong>/g, '').replace(/<span[^>]*>\s*<\/span>/g, '');
  }
  // Usamos una expresión regular para buscar y eliminar las etiquetas <strong> y <span> vacías
  return text;
}


export function stripHtml(html) {
  if (!html) return '';

  // Primero decodificamos los caracteres especiales
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  // Luego eliminamos las etiquetas HTML
  return decodedHtml.replace(/<[^>]*>/g, '');
}
